import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import axios from 'axios';
import { APIURL } from '../../config'
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Link from '@mui/material/Link';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import moment from 'moment';
import { useReactToPrint } from 'react-to-print';
import Typography from '@mui/material/Typography';
import HandyCard from '../HandyCard/HandyCard';
import ViewMTModal from '../SupportCoordinator/Modals/ViewMTModal';


const ReviewMMT = (props) => {

    const [status, setStatus] = useState('');
    const [note, setNote] = useState('');
    const [data, setData] = useState({});
    const [type, setType] = useState('');
    const [mmId , setMMId] = useState('');

    const [artifactsDisplay, setArtifactsDisplay] = useState([]);

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [showDoc, setShowDoc] = useState(false);
    const handleDocClose = () => setShowDoc(false);
    const handleDocShow = () => setShowDoc(true);

    // Depend on the specific props (not the whole props object) so ancestor re-renders
    // don't re-run this and wipe the reviewer name/date the manager typed into Section 11/16.
    useEffect(() => {
        if(props.mm) {
            setData(JSON.parse(props.mm.data));
            setType(props.mm.mt_type);
            setNote(props.mm.comment ? props.mm.comment : '');
            setMMId(props.mm.monthly_monitoring_id);
        } else {
            setNote('');
        }
        setStatus(props.status);
        setArtifactsDisplay(props.artifacts ? props.artifacts.sort((a, b) => new Date(a.submitted) - new Date(b.submitted)) : []);
    }, [props.mm, props.status, props.artifacts])

    const handleSelectChange = (event) => {
        setStatus(event.target.value);
    };

    const handleTextChange = (event) => {
        setNote(event.target.value);
    };

    const onSubmit = async () => {
        if(status !== '') {
            // Reviewer name/date entered by the manager in Section 11 (Monthly) / Section 16 (Quarterly)
            const reviewerSection = type === 'Quarterly' ? data?.section_16 : data?.section_11;
            const reviewer_name = reviewerSection?.a?.answer ? String(reviewerSection.a.answer) : null;
            const reviewer_date = reviewerSection?.b?.answer && moment(reviewerSection.b.answer).isValid() ? moment(reviewerSection.b.answer).format('YYYY-MM-DD') : null;
            var sha1 = require('sha1');
            let sessionID=window.localStorage.getItem('Fw4_access_Token')
            var hash = sha1(sessionID);
            var log_data={
                emp_id: props.user.emp_id,
                actionType:'MT Form Action',
                actionSubType:'MT Form' + ' ' + status?.toLocaleLowerCase(),
                actionDetail: mmId,
                sessionID: hash
            }                                                                                                                                                                                                                                                               
            let msg = await axios.post(APIURL+"/activity_log", log_data );
            // Update the monthlymonitoring flags AND the task status atomically so they can
            // never diverge (previously a transient failure on the second call could leave the
            // task 'Approved' while the monthlymonitoring row stayed at its default state).
            let review_res = await axios.put(APIURL+"/monthlymonitoring/review", {
                task_id: props.mm.task_id,
                emp_id: props.mm.employee_id,
                approved: status==='Approved'?1:0,
                submitted: true,
                comment: note,
                initial_submission_date: props.mm.initial_submission_date,
                submitted_on: props.mm.submitted_on,
                reviewed_on: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
                mt_type: props.mm.mt_type,
                is_annual: props.mm.is_annual ? props.mm.is_annual : 0,
                loc16: props.mm.loc16 ? props.mm.loc16 : 0,
                tas_mm_status: status,
                reviewer_name: reviewer_name,
                reviewer_date: reviewer_date,
            });
            if(review_res.data?.code === 200) {
                // Fire notifications/analytics best-effort. A failure here can no longer leave
                // the task status and monthlymonitoring flags out of sync since they were
                // committed together above.
                try {
                    await axios.put(APIURL+"/task/status", {empId: props.user.emp_id, empName: props.user.emp_name, companyId: props.user.comp_id, tas_id: props.mm.task_id, tas_mm_status: status, submittedByEmpId: props.mm.employee_id, submittedByEmpName: props.emp_name });
                } catch (notifyErr) {
                    console.log('MT review notification failed', notifyErr);
                }
                props.updateTaskStatus(props.id, status, props.task.tas_id, props.month);
                props.handleClose();
            }
        }
    }
    
    return (
        <Box>
            <Dialog disableEnforceFocus open={props.show} onClose={props.handleClose} maxWidth="sm" fullWidth sx={{ zIndex: 1 }}>
                <DialogTitle>Review Monitoring Tool</DialogTitle>
                <DialogContent dividers>
                    <Stack spacing={3} sx={{ mt: 2, px: 3 }}>
                        <Stack direction="row" alignItems="center" spacing={1}>
                            <Typography variant="subtitle1">MT Form:</Typography>
                            <Link href="#" onClick={handleShow} underline="always">
                                {(props.emp_name + " " + props.cus_name + " " + type + " Monitoring Tool").replace(/ /g, '_')}
                            </Link>
                        </Stack>
                        <FormControl fullWidth>
                            <InputLabel id="review-status-label">Status</InputLabel>
                            <Select
                                labelId="review-status-label"
                                id="review-status-select"
                                value={status}
                                label="Status"
                                onChange={handleSelectChange}
                            >
                                <MenuItem value="Approved">Approved</MenuItem>
                                <MenuItem value="Rejected">Rejected</MenuItem>
                            </Select>
                        </FormControl>
                        <TextField
                            fullWidth
                            multiline
                            rows={10}
                            id="notes-field"
                            label="Notes"
                            value={note}
                            inputProps={{ maxLength: 7000 }}
                            onChange={handleTextChange}
                        />
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                        <Button variant='outlined' onClick={handleDocShow}>Documents</Button>
                        <Box>
                            <Button variant='outlined' onClick={props.handleClose} sx={{ mr: 1 }}>Cancel</Button>
                            <Button variant='contained' onClick={onSubmit}>Submit</Button>
                        </Box>
                    </Box>
                </DialogActions>
            </Dialog>
            <ViewMTModal 
                user={props.user}
                show={show} 
                handleClose={handleClose} 
                data={data}
                mm_id={mmId}
                type={type} 
                cus_name={props.cus_name}
                checkoutEmpDate={props.task?.checkoutEmpDate}
                setNote={handleTextChange}
                note={note}
                review={true}
                onDataChange={(newData) => setData({...newData})}
            />
            <Dialog open={showDoc} onClose={handleDocClose} maxWidth="md" fullWidth>
                <DialogTitle>Documents</DialogTitle>
                <DialogContent dividers sx={{ px: 3, py: 2 }}>
                    <Stack direction="row" spacing={2} sx={{ overflowX: 'auto' }}>
                        {artifactsDisplay.map((artifact) => (
                            <HandyCard
                                key={artifact.id}
                                artifact={true}
                                fileName={artifact.file_name}
                                fileType={artifact.url.split('.').pop()}
                                taskName={artifact.tas_title}
                                empName={artifact.emp_name}
                                url={artifact.url}
                                date={artifact.submitted}
                                pname={artifact.pro_title}
                            />
                        ))}
                    </Stack>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Button variant="contained" onClick={handleDocClose}>Close</Button>
                </DialogActions>
            </Dialog>
        </Box>
        
    )
}

export default ReviewMMT
